import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  justify-self: center;
  margin: 5% auto;
  width: 50%;
  border-radius: 8px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  background: #fff;
  padding: 16px 16px;

  section {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .btn1 {
      width: 18%;
      padding: 0.375rem 0.5rem;
      margin-left: 8px;
      transition: 500ms;
    }

    .btn2 {
      width: 22%;
      padding: 0.375rem 0.5rem;
    }
  }
`;
